import React, { useEffect, useState } from "react";
import {
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const DeliveryPinCode = () => {
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const [productData, setProductData] = useState([]);
  const [open1, setOpen1] = React.useState(false);
  // const [page, setPage] = React.useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  // Add category Name start
  const [mainCategoryId, setMainCategoryId] = useState(null);
  const [product_category_name, setProduct_category_name] = useState("");
  const [image, setImage] = useState("");
  // const [description, setDescription] = useState("");
  const [meta_title, setMeta_title] = useState("");
  const [meta_description, setMeta_description] = useState("");
  const [meta_keyword, setMeta_keyword] = useState("");
  const storeId = localStorage.getItem("store_id");
  // const superuserId = localStorage.getItem("is_superuser");
  const superuserId = "true";

  const Page = (e) => {
    console.log(e.target.files);
    setImage(e.target.files[0]);
  };

  const submitCategory = () => {
    const fd = new FormData();
    fd.append("main_category_id", mainCategoryId);
    fd.append("product_category_name", product_category_name);
    // fd.append("description", description);
    mainCategoryId === null
      ? fd.append("image", image)
      : image && fd.append("image", image);
    fd.append("meta_title", meta_title);
    fd.append("meta_description", meta_description);
    fd.append("meta_keyword", meta_keyword);
    mainCategoryId !== null && fd.append("store_id", storeId);
    mainCategoryId === null
      ? axios
          .post(
            `https://app1.crazzyhub.com/api/admin/multivendor-add-product-category/`,
            fd,
            {
              headers: {
                Token: localStorage.getItem("Token"),
                "Content-Type": "multipart/formdata",
              },
            }
          )
          .then((response) => {
            toast.success(response.data.message);
            console.log("business store ==>", response.data.data);
            handleClose1();
            ProductDataList();
          })
          .catch((error) => {
            console.log("error page", error.response);
            console.log(error);
          })
      : // Edit functionality to business category
        axios
          .post(
            `https://app1.crazzyhub.com/api/admin/update-main-category-data/`,
            fd,
            {
              headers: {
                Token: localStorage.getItem("Token"),
                "Content-Type": "multipart/formdata",
              },
            }
          )
          .then((response) => {
            toast.success(response.data.message);
            handleClose1();
            ProductDataList();
          })
          .catch((error) => {
            console.log("error page", error.response);
            console.log(error);
          });
  };

  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const ProductDataList = () => {
    superuserId !== "true"
      ? axios
          .post(
            `https://app1.crazzyhub.com/api/admin/multivendor-show-main-category-list/?page=${page}&search=${searchQuery}`,
            {},
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            }
          )
          .then((response) => {
            console.log(
              "category list data===>",
              response?.data?.main_category_data
            );

            setCurrentPage(response.data.current_page);
            setTotalPage(response.data.total_pages);
            setProductData(response?.data?.main_category_data);
          })
          .catch((error) => {
            console.log("", error);
          })
      : axios
          .post(
            `https://app1.crazzyhub.com/api/admin/multivendor-show-main-category-list/?page=${page}&search=${searchQuery}`,
            { search: searchQuery },
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            }
          )
          .then((response) => {
            setCurrentPage(response.data.current_page);
            setTotalPage(response.data.total_pages);
            setProductData(response?.data?.main_category_data);
          })
          .catch((error) => {
            console.log("", error);
          });
  };
  useEffect(() => {
    ProductDataList();
  }, [page, searchQuery]);

  const EditFunction = (row) => {
    setMainCategoryId(row?.id);
    setProduct_category_name(row?.category);
    setMeta_description(row?.Meta_Description);
    setMeta_title(row?.Meta_Title);
    setMeta_keyword(row?.Meta_Keyword);
  };

  const hangleCancel = () => {
    setMainCategoryId("");
    setProduct_category_name("");
    setMeta_description("");
    setMeta_title("");
    setMeta_keyword("");
    handleClose1();
    ProductDataList();
  };

  const handleOpenModal = () => {
    setProduct_category_name("");
    setMeta_description("");
    setMeta_title("");
    setMeta_keyword("");
    setMainCategoryId("");
  };
  const deleteCategory = (id) => {
    axios
      .delete(
        `https://app1.crazzyhub.com/api/admin/update-main-category-data/`,
        {
          data: {
            main_category_id: id,
            // store_id: StoreID,
          },

          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        if (response.data.response_code == 200) {
          toast.success(response.data.message);
          ProductDataList();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log("error page", error.response);
        console.log(error);
      });
    // }
  };
  const handleChangePage = (event, value) => {
    setPage(value);
  };
  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Category List
          </p>
        </div>
        <div className="p-2 pt-5"></div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            <input
              type="text"
              value={searchQuery}
              className="!border-3 !border-black !w-72 mx-3 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3">
              {superuserId === "true" ? (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleOpen1}
                >
                  <AddIcon />
                  Add Category
                </Button>
              ) : null}
              <Modal
                open={open1}
                onClose={handleClose1}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 430 }}
                  className="rounded-2xl !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                    onClick={handleOpenModal}
                  >
                    {mainCategoryId === null
                      ? "Add Category"
                      : "Update Category"}
                  </div>
                  <TextField
                    size="small"
                    value={product_category_name}
                    onChange={(event) =>
                      setProduct_category_name(event.target.value)
                    }
                    id="outlined-basic"
                    label="Category Name"
                    variant="outlined"
                    className="!w-[100%] !mt-2"
                  />
                  <br />
                  <TextField
                    onChange={Page}
                    id="outlined-basic"
                    type="file"
                    size="small"
                    className="!w-[100%] !mt-3"
                  />
                  <br />
                  <TextField
                    value={meta_title}
                    onChange={(event) => setMeta_title(event.target.value)}
                    id="outlined-basic"
                    label="Title"
                    size="small"
                    variant="outlined"
                    className="!w-[100%] !mt-3"
                  />
                  <br />
                  <TextField
                    value={meta_description}
                    onChange={(event) =>
                      setMeta_description(event.target.value)
                    }
                    id="outlined-basic"
                    // defaultValue="Small"
                    size="small"
                    label="Meta Description"
                    variant="outlined"
                    className="!w-[100%] !mt-3"
                  />
                  <br />
                  <TextField
                    value={meta_keyword}
                    onChange={(event) => setMeta_keyword(event.target.value)}
                    id="outlined-basic"
                    label="Meta Keyword"
                    // defaultValue="Small"
                    size="small"
                    variant="outlined"
                    className="!w-[100%] !mt-2"
                  />
                  <br />
                  <Button
                    onClick={hangleCancel}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  {mainCategoryId === null ? (
                    <Button
                      variant="contained"
                      color="success"
                      className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                      onClick={submitCategory}
                    >
                      ADD
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="success"
                      className="!py-2 !px-5 !mt-3 !font-bold !float-right"
                      onClick={submitCategory}
                    >
                      UPDATE
                    </Button>
                  )}
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: "71vh" }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  BUSINESS TYPE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  BUSINESS SUB TYPE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  CATEGORY
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  IMAGE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  STATUS
                </TableCell>
                {superuserId === "true" ? (
                  <TableCell
                    style={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    ACTION
                  </TableCell>
                ) : null}
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {productData &&
                productData?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.business_type?.business_type?.name
                        ? row?.business_type?.business_type?.name
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {" "}
                      {row?.business_type?.name
                        ? row?.business_type?.name
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.category ? row.category : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.image ? (
                        <img
                          src={row?.image}
                          alt="No"
                          className="h-8 mx-auto w-8"
                        />
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.is_active_for_user ? (
                        <CheckCircleIcon className="text-green-500" />
                      ) : (
                        "--"
                      )}
                    </TableCell>

                    {superuserId === "true" ? (
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <DeleteIcon
                          onClick={() => deleteCategory(row.id)}
                          className="!text-xl !text-red-600 !cursor-pointer"
                        />
                        <button onClick={handleOpen1}>
                          <EditIcon
                            className="!text-xl !cursor-pointer !text-green-600"
                            onClick={() => EditFunction(row)}
                          />
                        </button>
                      </TableCell>
                    ) : null}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          {/* {totalPage !== 1 && ( */}
          <div className="flex justify-center p-2">
            <Pagination
              page={currentPage}
              size="small"
              count={totalPage}
              variant="outlined"
              color="primary"
              onChange={handleChangePage}
            />
          </div>
          {/* )} */}
        </TableContainer>
      </div>
    </div>
  );
};

export default DeliveryPinCode;
